import React from "react";
import PublicTopNav from "./PublicTopNav";
import styles from "./PublicPageShell.module.css";

export default function PublicPageShell({
  acc,
  t,
  navigateToPage,
  showBrandClick = true,
  analyticsScreen = "public",
  locale,
  setLocale,
  onLocaleNavigate = null,
  LanguageSwitcher,
  children,
}) {
  return (
    <div className={styles.page}>
      <PublicTopNav
        acc={acc}
        t={t}
        navigateToPage={navigateToPage}
        showBrandClick={showBrandClick}
        analyticsScreen={analyticsScreen}
        locale={locale}
        setLocale={setLocale}
        onLocaleNavigate={onLocaleNavigate}
        LanguageSwitcher={LanguageSwitcher}
      />
      <div className={styles.content}>{children}</div>
    </div>
  );
}
